export const form = () => {
  $('input, textarea, select')
    .on('change', function () {
      var $input = $(this);
      var isRequired = $input.parents('.field').is('.field_contains_required');
      var isValid = $input.is(':valid');

      if (isRequired && isValid) {
        //$input.parents('.gfield').addClass('gfield_valid');

        $input
          .parents('.field')
          .removeClass('field_error')
          .addClass('field_valid');

        //$input.parent().next('.validation_message').slideUp();
      }

      if ($input.val()) {
        //console.log($input.val());
      }
      $input.parents('.field').toggleClass('has-value', !!$input.val());
    })
    .blur(function () {
      var $input = $(this);
      var isRequired = $input.parents('.field').is('.field_contains_required');
      var isInValid = $input.is(':invalid');
      var isEmpty = $input.val() === '';

      if (isRequired && (isInValid || isEmpty)) {
        $input.parents('.field').removeClass('field_valid');

        //   $input
        //   .parents('.gfield')
        //   .addClass('gfield_error')
        //   .removeClass('gfield_valid');
        //$input.parent().next('.validation_message').slideDown();
      }
    });

  $('#signup-form').submit(function (e) {
    //e.preventDefault();
    var first_name = $('[name="first name"]').val();
    var last_name = $('[name="last name"]').val();
    var email = $('[name=email]').val();
    var age = $('[name=age]').val();
    var zipcode = $('[name=zip]').val();
    var hasErrors = false;

    $('.has-error').removeClass('has-error');
    $('.error').remove();

    if (first_name.length < 1) {
      console.log('has error');
      $('[name="first name"]')
        .after('<span class="error">This field is required</span>')
        .closest('.field')
        .addClass('has-error');
      hasErrors = true;
    }
    if (last_name.length < 1) {
      $('[name="last name"]')
        .after('<span class="error">This field is required</span>')
        .closest('.field')
        .addClass('has-error');
      hasErrors = true;
    }
    if (age.length < 1) {
      $('[name=age]')
        .after('<span class="error">This field is required</span>')
        .closest('.field')
        .addClass('has-error');
      hasErrors = true;
    }
    if (zipcode.length < 1) {
      $('[name=zip]')
        .after('<span class="error">This field is required</span>')
        .closest('.field')
        .addClass('has-error');
      hasErrors = true;
    }
    if (email.length < 1) {
      $('[name=email]')
        .after('<span class="error">This field is required</span>')
        .closest('.field')
        .addClass('has-error');
      hasErrors = true;
    } else {
      var regEx =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      var validEmail = regEx.test(email);
      if (!validEmail) {
        $('[name=email]')
          .after('<span class="error">Enter a valid email</span>')
          .closest('.field')
          .addClass('has-error');
        hasErrors = true;
      }
    }

    console.log(hasErrors);

    if (hasErrors) {
      return false;
    } else {
      return true;
    }
  });
};
